var _defs, _path, _defs2, _path2, _defs3, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaves(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    id: "svg",
    viewBox: "0 0 1440 400",
    xmlns: "http://www.w3.org/2000/svg",
    className: "transition duration-300 ease-in-out delay-150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#a8daec66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#a8daec66"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 0,400 C 0,400 0,100 0,100 C 65.29714874613535,98.58399175541052 130.5942974922707,97.16798351082103 197,100 C 263.4057025077293,102.83201648917897 330.91995877705256,109.91205771212641 398,101 C 465.08004122294744,92.08794228787359 531.7258673995191,67.18378564067332 607,74 C 682.2741326004809,80.81621435932668 766.176571624871,119.35279972518035 838,130 C 909.823428375129,140.64720027481965 969.5678461009963,123.4050154586053 1027,112 C 1084.4321538990037,100.5949845413947 1139.5520439711438,95.02713844039847 1208,94 C 1276.4479560288562,92.97286155960153 1358.2239780144282,96.48643077980077 1440,100 C 1440,100 1440,400 1440,400 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "url(#gradient)",
    className: "transition-all duration-300 ease-in-out delay-150 path-0",
    transform: "rotate(-180 720 200)"
  })), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#a8daec66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#a8daec66"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,400 C 0,400 0,200 0,200 C 81.74029543112331,196.9055307454483 163.48059086224663,193.8110614908966 229,197 C 294.51940913775337,200.1889385091034 343.8179319821367,209.66128478186187 398,217 C 452.1820680178633,224.33871521813813 511.2476812092066,229.5437993816558 582,225 C 652.7523187907934,220.4562006183442 735.1913431810373,206.16351769151493 814,194 C 892.8086568189627,181.83648230848507 967.9869460666439,171.80212985228445 1032,179 C 1096.013053933356,186.19787014771555 1148.8608725523873,210.62796289934727 1215,217 C 1281.1391274476127,223.37203710065273 1360.5695637238064,211.68601855032637 1440,200 C 1440,200 1440,400 1440,400 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "url(#gradient)",
    className: "transition-all duration-300 ease-in-out delay-150 path-1",
    transform: "rotate(-180 720 200)"
  })), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient",
    x1: "0%",
    y1: "50%",
    x2: "100%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "5%",
    stopColor: "#a8daec66"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "95%",
    stopColor: "#a8daec66"
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 0,400 C 0,400 0,300 0,300 C 78.44658193060806,280.60803847475097 156.89316386121612,261.2160769495019 227,271 C 297.1068361387839,280.7839230504981 358.8739264857437,319.74373067674344 421,335 C 483.1260735142563,350.25626932325656 545.611130195809,341.8090003435246 606,323 C 666.388869804191,304.1909996564754 724.6815527310202,275.0202679491584 785,263 C 845.3184472689798,250.97973205084162 907.6626588801098,256.10992785984195 993,273 C 1078.3373411198902,289.89007214015805 1186.6678117485399,318.5400206114737 1265,325 C 1343.3321882514601,331.4599793885263 1391.66609412573,315.72998969426317 1440,300 C 1440,300 1440,400 1440,400 Z",
    stroke: "none",
    strokeWidth: 0,
    fill: "url(#gradient)",
    className: "transition-all duration-300 ease-in-out delay-150 path-2",
    transform: "rotate(-180 720 200)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.ccfdd72c4396135fd8d1bf54aa268fef.svg";
export { ForwardRef as ReactComponent };